import { RefObject, useEffect } from 'react'

import { LiveTrackEventType, trackLiveImpression } from '@/methods/liveTracking'

interface Params {
  ref: RefObject<Element | null>
  type: LiveTrackEventType
  roomId?: string
  productId?: number
  source?: string
  enabled?: boolean
}

const VISIBLE_RATIO = 0.5 // 露出一半以上
const VISIBLE_MS = 1000 // 且連續停留 1 秒，才算一次有效曝光

// 直播封面、直播間商品卡的有效曝光（同一頁面內同一個目標只記一次，見 trackLiveImpression）
const useLiveImpression = ({ ref, type, roomId, productId, source, enabled = true }: Params) => {
  useEffect(() => {
    const el = ref.current
    if (!enabled || !el || !roomId || typeof IntersectionObserver === 'undefined') return

    let timer: ReturnType<typeof setTimeout> | null = null
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && entry.intersectionRatio >= VISIBLE_RATIO) {
          timer ??= setTimeout(() => {
            trackLiveImpression({ type, roomId, productId, source })
            observer.disconnect()
          }, VISIBLE_MS)
        } else if (timer) {
          clearTimeout(timer)
          timer = null
        }
      },
      { threshold: [0, VISIBLE_RATIO] },
    )
    observer.observe(el)

    return () => {
      timer && clearTimeout(timer)
      observer.disconnect()
    }
  }, [ref, type, roomId, productId, source, enabled])
}

export default useLiveImpression
